(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arbiter-device-selector"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('arbiter-device-selector')) return;

    class ArbiterDeviceSelector extends HTMLElement {
      connectedCallback() {
        this.readyHandler = () => this.initialize();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.readyHandler, { once: true });
        } else {
          this.initialize();
        }
      }

      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.readyHandler);
        if (this.listeners) this.listeners.abort();
        this.initialized = false;
      }

      initialize() {
        if (this.initialized || !this.isConnected) return;
        this.initialized = true;
        this.listeners = new AbortController();
        const options = { signal: this.listeners.signal };
        this.input = this.querySelector('[data-search-input]');
        this.count = this.querySelector('[data-group-count]');
        this.noResults = this.querySelector('[data-no-results]');
        this.searching = false;
        this.groups = Array.from(this.querySelectorAll('[data-device-group]')).map(element => {
          const details = element.querySelector('[data-group-details]');
          const group = {
            element,
            details,
            title: this.normalize(element.dataset.groupName),
            count: element.querySelector('[data-model-count]'),
            originalCount: element.querySelector('[data-model-count]').textContent.trim(),
            wasOpen: details.open,
            rows: Array.from(element.querySelectorAll('[data-device-block]')).map(row => ({
              element: row,
              text: this.normalize(row.dataset.deviceName + ' ' + row.dataset.keywords)
            }))
          };
          details.addEventListener('toggle', () => element.classList.toggle('is-open', details.open), options);
          return group;
        });

        const searchWrapper = this.querySelector('[data-search-wrapper]');
        if (searchWrapper) searchWrapper.hidden = false;
        if (this.input) this.input.addEventListener('input', () => this.filter(), options);

        this.addEventListener('shopify:block:select', event => {
          const blockId = event.detail && event.detail.blockId;
          const group = this.groups.find(candidate => candidate.rows.some(row => row.element.dataset.blockId === blockId));
          if (!group) return;
          if (this.input) this.input.value = '';
          this.filter();
          group.element.hidden = false;
          group.details.open = true;
          group.element.classList.add('is-open');
          const selected = group.rows.find(row => row.element.dataset.blockId === blockId);
          if (selected) selected.element.scrollIntoView({ block: 'nearest', behavior: 'auto' });
        }, options);
        this.filter();
      }

      normalize(value) {
        return String(value || '').normalize('NFKC').toLocaleLowerCase().replace(/[^\p{L}\p{N}+]/gu, '');
      }

      filter() {
        const terms = (this.input ? this.input.value : '').split(/\s+/).map(term => this.normalize(term)).filter(Boolean);
        const query = terms.join('');
        if (query && !this.searching) this.groups.forEach(group => { group.wasOpen = group.details.open; });
        let visibleGroups = 0;
        this.groups.forEach(group => {
          let visibleRows = 0;
          group.rows.forEach(row => {
            const visible = !query || terms.every(term => (group.title + ' ' + row.text).includes(term));
            row.element.hidden = !visible;
            if (visible) visibleRows++;
          });
          group.element.hidden = visibleRows === 0;
          if (visibleRows > 0) visibleGroups++;
          if (query) {
            group.details.open = visibleRows > 0;
            group.count.textContent = visibleRows + ' ' + (visibleRows === 1 ? this.dataset.modelSingular : this.dataset.modelPlural);
          } else {
            if (this.searching) group.details.open = group.wasOpen;
            group.count.textContent = group.originalCount;
          }
          group.element.classList.toggle('is-open', group.details.open);
        });
        this.searching = Boolean(query);
        this.count.textContent = visibleGroups + ' ' + (visibleGroups === 1 ? this.dataset.groupSingular : this.dataset.groupPlural);
        this.noResults.hidden = visibleGroups > 0 || this.groups.length === 0;
      }
    }

    customElements.define('arbiter-device-selector', ArbiterDeviceSelector);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nijisanji-liver-showcase"] && !Shopify.designMode) return;
  try {
    
(() => {
  class NijiShowcase extends HTMLElement {
    static instances = new Set();
    static language = null;
    static storageKey = 'niji-showcase-language-v1';

    connectedCallback() {
      this.startFrame = requestAnimationFrame(() => this.mount());
    }

    mount() {
      if (!this.isConnected || this.events) return;
      this.events = new AbortController();
      this.switcher = this.querySelector('[data-niji-switch]');
      const designMode = Boolean(window.Shopify && window.Shopify.designMode);
      const owner = document.querySelector('as-niji-showcase[data-has-language-switch="true"]') || this;
      if (!NijiShowcase.language || designMode) {
        NijiShowcase.language = owner.dataset.defaultLanguage === 'ja' ? 'ja' : 'en';
        if (!designMode && owner.dataset.rememberLanguage === 'true') {
          try {
            const saved = localStorage.getItem(NijiShowcase.storageKey);
            if (saved === 'en' || saved === 'ja') NijiShowcase.language = saved;
          } catch (_) { /* Browsers may disable storage; the switch still works. */ }
        }
      }
      NijiShowcase.instances.add(this);
      if (this.switcher) {
        // Keep the fixed control outside any theme container with overflow/transform.
        document.body.appendChild(this.switcher);
        this.switcher.addEventListener('click', event => {
          const button = event.target.closest('[data-niji-set-language]');
          if (!button) return;
          this.changeLanguage(button.dataset.nijiSetLanguage, true);
        }, { signal: this.events.signal });
      }
      this.changeLanguage(NijiShowcase.language);
      NijiShowcase.refreshSwitchers();
    }

    changeLanguage(language, remember = false) {
      if (language !== 'en' && language !== 'ja') return;
      NijiShowcase.language = language;
      NijiShowcase.instances.forEach(instance => instance.applyLanguage(language));
      if (remember && this.dataset.rememberLanguage === 'true' && !(window.Shopify && window.Shopify.designMode)) {
        try { localStorage.setItem(NijiShowcase.storageKey, language); } catch (_) { /* Storage is optional. */ }
      }
    }

    applyLanguage(language) {
      this.dataset.language = language;
      this.lang = language;
      this.querySelectorAll('[data-niji-language]').forEach(node => {
        node.toggleAttribute('hidden', node.dataset.nijiLanguage !== language);
      });
      [this, ...this.querySelectorAll('[data-niji-label-en]')].forEach(node => {
        const label = node.getAttribute(`data-niji-label-${language}`) || node.getAttribute('data-niji-label-en');
        if (label !== null) node.setAttribute('aria-label', label);
      });
      this.querySelectorAll('[data-niji-alt-en]').forEach(node => {
        const alt = node.getAttribute(`data-niji-alt-${language}`) || node.getAttribute('data-niji-alt-en');
        const img = node.querySelector('img');
        if (img) img.alt = alt || '';
      });
      this.switcher?.querySelectorAll('[data-niji-set-language]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.nijiSetLanguage === language));
      });
      this.querySelectorAll('as-niji-carousel').forEach(carousel => carousel.localize?.());
    }

    static refreshSwitchers() {
      // Several showcase instances share one fixed control instead of overlapping.
      let shown = false;
      NijiShowcase.instances.forEach(instance => {
        if (!instance.switcher) return;
        instance.switcher.hidden = shown;
        shown = true;
      });
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.startFrame);
      this.events?.abort();
      this.events = null;
      if (this.switcher) {
        this.switcher.hidden = true;
        this.appendChild(this.switcher);
      }
      NijiShowcase.instances.delete(this);
      NijiShowcase.refreshSwitchers();
      if (!NijiShowcase.instances.size) NijiShowcase.language = null;
    }
  }

  class NijiCarousel extends HTMLElement {
    connectedCallback() {
      this.startFrame = requestAnimationFrame(() => this.mount());
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.startFrame);
      this.stopTimer();
      if (this.events) this.events.abort();
      if (this.observer) this.observer.disconnect();
      this.sizeObserver?.disconnect();
      this.querySelectorAll('[data-niji-clone]').forEach(node => node.remove());
      this.querySelectorAll('[data-niji-slide]').forEach(node => {
        node.hidden = false;
        node.removeAttribute('aria-hidden');
        node.removeAttribute('data-active');
        node.removeAttribute('data-side');
      });
      this.removeAttribute('data-ready');
      this.removeAttribute('data-single');
      this.events = null;
    }

    mount() {
      if (!this.isConnected || this.events) return;
      this.originals = Array.from(this.querySelectorAll('[data-niji-slide]'));
      this.count = this.originals.length;
      this.track = this.querySelector('.niji-track');
      if (!this.count || !this.track) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.index = 0;
      this.visible = true;
      this.hovered = false;
      this.autoRequested = this.dataset.autoplay === 'true';
      this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = this.motionQuery.matches || Boolean(window.Shopify && window.Shopify.designMode);
      this.delay = Math.max(3000, Number(this.dataset.delay) || 5000);
      this.cards = this.originals.slice();
      this.clones = [];

      // With two images, repeat the other image on both sides of the center.
      // A single image gets a static gallery without controls.
      if (this.count === 2) {
        this.clones = this.originals.map(original => {
          const clone = original.cloneNode(true);
          clone.setAttribute('data-niji-clone', '');
          clone.removeAttribute('data-niji-slide');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
          this.track.appendChild(clone);
          return clone;
        });
        this.cards.push(...this.clones);
      }

      this.setAttribute('data-ready', '');
      this.toggleAttribute('data-single', this.count === 1);
      this.querySelectorAll('[data-prev], [data-next], .niji-gallery-controls').forEach(node => {
        node.hidden = this.count < 2;
      });
      const controls = this.querySelector('.niji-gallery-controls');
      if (controls && !controls.children.length) controls.hidden = true;
      this.localize();
      this.update(false);
      this.updatePlayButton();
      this.updateImageSizes();
      window.addEventListener('resize', () => this.updateImageSizes(), options);
      if ('ResizeObserver' in window) {
        this.sizeObserver = new ResizeObserver(() => this.updateImageSizes());
        this.sizeObserver.observe(this.track);
      }
      if (this.count < 2) return;

      this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1, true), options);
      this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1, true), options);
      this.querySelectorAll('[data-go]').forEach(button => {
        button.addEventListener('click', () => this.go(Number(button.dataset.go), true), options);
      });
      this.querySelector('[data-toggle-play]')?.addEventListener('click', () => {
        this.userPaused = !this.userPaused;
        this.updatePlayButton();
        this.schedule();
      }, options);
      this.addEventListener('keydown', event => {
        if (event.altKey || event.ctrlKey || event.metaKey) return;
        let target;
        if (event.key === 'ArrowLeft') target = this.index - 1;
        if (event.key === 'ArrowRight') target = this.index + 1;
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = this.count - 1;
        if (target === undefined) return;
        event.preventDefault();
        this.go(target, true);
      }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.stopTimer(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      // Keyboard focus or manual interaction pauses automatic rotation until Play.
      this.addEventListener('focusin', () => this.pause(), options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      document.addEventListener('shopify:block:select', event => {
        const owner = this.closest('.niji-device');
        if (owner && (owner === event.target || owner.contains(event.target))) this.pause();
      }, options);
      this.motionQuery.addEventListener('change', event => {
        if (event.matches) this.pause();
      }, options);

      this.track.addEventListener('pointerdown', event => {
        if (!event.isPrimary || event.button !== 0) return;
        this.pause();
        this.pointer = { id: event.pointerId, x: event.clientX, dx: 0, target: event.target.closest('.niji-slide') };
        this.track.setPointerCapture(event.pointerId);
        this.setAttribute('data-dragging', '');
      }, options);
      this.track.addEventListener('pointermove', event => {
        if (!this.pointer || this.pointer.id !== event.pointerId) return;
        this.pointer.dx = event.clientX - this.pointer.x;
        const limit = this.track.clientWidth * .6;
        const delta = Math.max(-limit, Math.min(limit, this.pointer.dx));
        this.track.style.setProperty('--niji-drag', `${delta}px`);
      }, options);
      const release = event => {
        if (!this.pointer || this.pointer.id !== event.pointerId) return;
        const { dx, target } = this.pointer;
        this.pointer = null;
        this.removeAttribute('data-dragging');
        this.track.style.removeProperty('--niji-drag');
        if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
        if (event.type === 'pointercancel') return;
        if (Math.abs(dx) > 35) this.go(this.index + (dx < 0 ? 1 : -1), true);
        else if (Math.abs(dx) < 8 && target && target.hasAttribute('data-side')) this.go(Number(target.dataset.index), true);
      };
      this.track.addEventListener('pointerup', release, options);
      this.track.addEventListener('pointercancel', release, options);

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.schedule();
        }, { threshold: .15 });
        this.observer.observe(this);
      }
      this.schedule();
    }

    updateImageSizes() {
      const width = this.track.clientWidth;
      if (!width) return;
      const styles = getComputedStyle(this);
      const percentage = parseFloat(styles.getPropertyValue('--niji-slide-width'));
      // If layout isn't measurable yet, retain the generous server-rendered sizes.
      if (!Number.isFinite(percentage) || percentage <= 0) return;
      const frameWidth = width * percentage / 100;
      const frameHeight = this.track.clientHeight || frameWidth / (parseFloat(styles.getPropertyValue('--niji-ratio')) || 1.5);
      const sideSpace = Math.max(0, (width - frameWidth) / 2);
      const requestedGap = parseFloat(styles.getPropertyValue('--niji-requested-slide-gap')) || 0;
      // Keep both faded neighbors visible even with a large center image.
      const gap = Math.max(0, Math.min(requestedGap, sideSpace - Math.min(12, sideSpace / 2)));
      this.style.setProperty('--niji-slide-gap', `${gap}px`);
      const cover = styles.getPropertyValue('--niji-fit').trim() === 'cover';
      this.cards.forEach(card => {
        const img = card.querySelector('img');
        if (!img) return;
        const sourceWidth = Number(img.getAttribute('width'));
        const sourceHeight = Number(img.getAttribute('height'));
        const ratio = sourceWidth > 0 && sourceHeight > 0 ? sourceWidth / sourceHeight : 0;
        // A wide image cropped into a tall frame needs more source pixels.
        const renderedWidth = cover && ratio ? Math.max(frameWidth, frameHeight * ratio) : frameWidth;
        const sizes = `${Math.max(1, Math.ceil(renderedWidth))}px`;
        if (img.sizes !== sizes) img.sizes = sizes;
      });
    }

    go(target, manual = false) {
      if (!this.count) return;
      if (manual) this.pause();
      this.index = ((target % this.count) + this.count) % this.count;
      this.update(manual);
      this.schedule();
    }

    update(announce) {
      const previous = (this.index - 1 + this.count) % this.count;
      const next = (this.index + 1) % this.count;
      this.cards.forEach(card => {
        card.hidden = true;
        card.removeAttribute('data-active');
        card.removeAttribute('data-side');
        card.setAttribute('aria-hidden', 'true');
      });
      const place = (card, offset) => {
        card.hidden = false;
        card.style.setProperty('--niji-offset', offset);
        if (offset === 0) {
          card.setAttribute('data-active', '');
          card.removeAttribute('aria-hidden');
        } else card.setAttribute('data-side', '');
      };
      place(this.originals[this.index], 0);
      if (this.count > 1) {
        place(this.originals[previous], -1);
        place(this.count === 2 ? this.clones[next] : this.originals[next], 1);
      }
      this.querySelectorAll('[data-go]').forEach(button => {
        button.setAttribute('aria-pressed', String(Number(button.dataset.go) === this.index));
      });
      if (announce) {
        this.querySelector('[data-live]').textContent = this.counterLabel(this.index);
      }
    }

    counterLabel(index) {
      return `${this.dataset.imageLabel} ${index + 1} ${this.dataset.ofLabel} ${this.count}`;
    }

    localize() {
      const owner = this.closest('as-niji-showcase');
      if (!owner || !this.cards) return;
      const japanese = owner.dataset.language === 'ja';
      const suffix = japanese ? 'Ja' : 'En';
      const label = key => owner.dataset[key + suffix] || owner.dataset[key + 'En'] || '';
      ['imageLabel', 'ofLabel', 'pauseLabel', 'playLabel'].forEach(key => {
        this.dataset[key] = label(key);
      });
      this.setAttribute('aria-roledescription', japanese ? 'カルーセル' : 'carousel');
      this.querySelector('[data-prev]')?.setAttribute('aria-label', label('previousLabel'));
      this.querySelector('[data-next]')?.setAttribute('aria-label', label('nextLabel'));
      this.cards.forEach(card => {
        card.setAttribute('aria-label', this.counterLabel(Number(card.dataset.index)));
        card.setAttribute('aria-roledescription', japanese ? 'スライド' : 'slide');
      });
      this.querySelectorAll('[data-go]').forEach(button => {
        button.setAttribute('aria-label', this.counterLabel(Number(button.dataset.go)));
      });
      const live = this.querySelector('[data-live]');
      if (live?.textContent) live.textContent = this.counterLabel(this.index);
      this.updatePlayButton();
    }

    pause() {
      this.userPaused = true;
      this.stopTimer();
      this.updatePlayButton();
    }

    updatePlayButton() {
      const button = this.querySelector('[data-toggle-play]');
      if (!button) return;
      const label = this.userPaused ? this.dataset.playLabel : this.dataset.pauseLabel;
      button.textContent = label;
      button.setAttribute('aria-label', label);
    }

    stopTimer() { clearTimeout(this.timer); }

    schedule() {
      this.stopTimer();
      if (!this.isConnected || !this.autoRequested || this.userPaused || this.hovered || !this.visible || document.hidden || this.count < 2) return;
      this.timer = setTimeout(() => this.go(this.index + 1), this.delay);
    }
  }

  class NijiIllustration extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => {
        if (!this.isConnected || this.events) return;
        this.events = new AbortController();
        this.updateWidth = () => {
          // clientWidth excludes the scrollbar, preventing horizontal overflow.
          // Measure this unshifted wrapper so nested theme gutters are included.
          const width = document.documentElement.clientWidth;
          if (!width) return;
          this.style.setProperty('--niji-banner-width', `${width}px`);
          this.style.setProperty('--niji-banner-offset', `${-this.getBoundingClientRect().left}px`);
        };
        this.updateWidth();
        window.addEventListener('resize', this.updateWidth, { signal: this.events.signal });
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(this.updateWidth);
          this.observer.observe(this);
          this.observer.observe(document.documentElement);
        }
      });
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.events?.abort();
      this.observer?.disconnect();
      this.events = null;
    }
  }

  if (!customElements.get('as-niji-illustration')) customElements.define('as-niji-illustration', NijiIllustration);
  if (!customElements.get('as-niji-carousel')) customElements.define('as-niji-carousel', NijiCarousel);
  if (!customElements.get('as-niji-showcase')) customElements.define('as-niji-showcase', NijiShowcase);
})();


  } catch(e) { console.error(e); }
})();
})();
